import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
// import YoutubePlayer from 'react-youtube-player';
import YouTube from "react-youtube"
import SvgPlay from "../_svgs/small/Play"
import "./YouTubeEmbed.scss"

export default function YoutubeEmbed({ embedId, classDecleration, backgroundImage, ariaVideoDescription }) {
  const [playbackState, setPlaybackState] = useState("paused")
  const [showVideoHtml, setShowVideoHtml] = useState(false)

  const [hasVideoLoaded, setHasVideoLoaded] = useState(false)
  const video = document.getElementById(embedId) || undefined

  useEffect(() => {
    if (!!video && !hasVideoLoaded) {
      const handleLoad = () => {
        setHasVideoLoaded(false)
      }

      video.addEventListener("load", handleLoad)

      return () => {
        video.removeEventListener("load", handleLoad)
      }
    }
  })

  const options = {
    playerVars: {
      showinfo: false,
      modestbranding: true,
      allowFullScreen: 1,
      title: "Embedded Youtube",
      autoPlay: 1,
      controls: 1,
      loop: 0,
      cc_load_policy: "0",
      iv_load_policy: "3",
      autohide: 0,
    },
  }

  function onPlayerReady(event) {
    var embedCode = event.target.getVideoEmbedCode()
    event.target.playVideo()
    if (document.getElementById("embed-code")) {
      document.getElementById("embed-code").innerHTML = embedCode
      document.getElementById("embed-code").focus()
    }
  }

  const playHandler = () => {
    setShowVideoHtml(true)
    setPlaybackState("playing")
  }

  let overlayStyle = {
    backgroundImage: `url('http://img.youtube.com/vi/${embedId}/0.jpg')`,
  }

  if (backgroundImage) {
    overlayStyle.backgroundImage = `url('${backgroundImage}')`
  }

  return (
    <div className={classDecleration}>
      {/* {playbackState !== 'playing' && !!backgroundImage ?
                <button className="youtube-overlay" onClick={playHandler} style={overlayStyle}>
                    <div className="svg-container">
                        <div className="youtube-play-svg">
                            <SvgPlay />
                        </div>
                    </div>
                </button> : undefined
            } */}
      {showVideoHtml ? (
        <YouTube videoId={embedId} id={embedId} className={"youtube-video"} title={"Embedded Youtube"} opts={options} onReady={onPlayerReady} />
      ) : (
        <button aria-label={ariaVideoDescription || "Start Video"} className="youtube-overlay" onClick={playHandler} style={overlayStyle}>
          <div className="svg-container">
            <div className="youtube-play-svg">
              <SvgPlay />
            </div>
          </div>
        </button>
      )}
    </div>
  )
}

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
  classDecleration: PropTypes.string,
  backgroundImage: PropTypes.string,
}
